import React, { FC, useEffect, useState } from 'react'
import Link from 'next/link'
import s from './ProductView.module.css'
import { ProductContent } from 'types/storyblok'
import Button from '@components/design/Button'
import { useRouter } from 'next/router'
import useSWR from 'swr'
import { isPurchasingLFMembership } from '@lib/helpers/cart'
import { useCart } from '@framework/cart'
import { SubscriptionsResponse } from 'types/subscription'
import { EnrichedProduct, PHARMA_SKUS } from '@lib/productCatalog'

const fetcher = (url: string) => fetch(url).then((res) => res.json())

const FREQUENCY_LABELS = {
  monthly: 'EVERY MONTH',
}

interface CallToActionProps {
  loading: boolean
  addToCart: () => void
  price: string
  story: ProductContent
  availableForSale: boolean
  frequency: string
  productSku?: string
}

const CallToAction: FC<CallToActionProps> = ({
  loading,
  addToCart,
  story,
  price,
  frequency,
  availableForSale,
  productSku,
}) => {
  const frequencyLabel =
    // @ts-ignore
    frequency !== 'one-time' && ` ${FREQUENCY_LABELS[frequency]}`
  const router = useRouter()

  const navigateToDiagnosticBundle = async () => {
    await router.push('/product/diagnostic-bundle')
    window.location.reload()
  }

  const { data: accountData } = useSWR('/api/account', fetcher)
  const { data: subscriptionData } = useSWR<SubscriptionsResponse>(
    '/api/account/subscriptions',
    fetcher
  )
  const [disableForMembership, setDisableForMembership] = useState(false)
  const cart: any = useCart()

  const isAllowedRx =
    accountData?.allowedRx
      ?.map((sku: string) => sku.toLowerCase())
      .includes(productSku?.toLowerCase()) &&
    (accountData?.isMember || isPurchasingLFMembership(cart.data))

  const hasProductSubscription = !!subscriptionData?.products?.find(
    (p: EnrichedProduct) => {
      return p.bcProduct.sku?.toLowerCase() == productSku?.toLocaleLowerCase()
    }
  )

  const rxInCart =
    PHARMA_SKUS.map((sku: string) => sku.toLowerCase()).includes(
      productSku!.toLowerCase()
    ) &&
    cart.data?.lineItems?.find(
      (item: any) =>
        item.variant.sku.toLowerCase() === productSku?.toLowerCase()
    )

  useEffect(() => {
    if (accountData) {
      const disableForMembership =
        accountData.customFields?.find(
          (field: any) =>
            field.name === 'hasLifeforceMembership' && field.value === '1'
        ) && story.category === 'program'
      setDisableForMembership(disableForMembership)
    }
  }, [accountData, story.category])

  return (
    <div>
      {((story && !story.requires_program) ||
        story.category == 'program' ||
        isAllowedRx) && (
        <div className="grid grid-cols-2">
          <Button
            aria-label="Add"
            color="primary"
            type="button"
            className={s.button}
            onClick={addToCart}
            loading={loading}
            disabled={
              availableForSale === false ||
              disableForMembership ||
              hasProductSubscription ||
              rxInCart
            }
          >
            {disableForMembership || hasProductSubscription || rxInCart
              ? `Already ${rxInCart ? 'Added' : 'Subscribed'}`
              : availableForSale === false
              ? 'Not Available'
              : 'Add'}
          </Button>
          <span className="font-semibold pl-10 items-center inline-flex">
            {price}
            {frequencyLabel && frequencyLabel}
          </span>

          {!isAllowedRx && (
            <a
              className="relative top-4 cursor-pointer"
              onClick={navigateToDiagnosticBundle}
            ></a>
          )}
        </div>
      )}
      {story &&
        story.requires_program &&
        story.category != 'program' &&
        !isAllowedRx && (
          <div>
            <div className="pb-4 bg-gray-300 text-sm my-5 p-4 text-center text-gray-800 border border-gray-500">
              <p className="mb-2">
                Pharmaceutical products are only available to members of the 
                <Link href="/products/lifeforce-membership">
                  <a> Lifeforce Personalized Performance Program.</a>
                </Link>
                {'  '}($129.00/month) and are contingent on blood tests results
                and clinician video consult.
              </p>
              <p>
                To qualify for the program you must reside in an eligible state*
                and purchase a diagnostic bundle. ($349.00)
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
              <Button type="button" sharp={true}>
                <Link href="/product/diagnostic-bundle">
                  <a className="relative">Build Your Plan</a>
                </Link>
              </Button>
              <span className="font-semibold justify-self-center sm:justify-self-start sm:pl-10 mt-2 sm:mt-0 inline-flex">
                {price}
                {frequencyLabel}
              </span>
            </div>
          </div>
        )}
      {/* {story && story.category == 'program' && (
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
            <Button type="button" sharp={true}>
              <Link href="/product/diagnostic-bundle">
                <a className="relative">Build Your Plan</a>
              </Link>
            </Button>
            <span className="font-semibold justify-self-center sm:justify-self-start sm:pl-10 mt-2 sm:mt-0 inline-flex">
              {price}
              {frequencyLabel}
            </span>
          </div>
        </div>
      )} */}
    </div>
  )
}

export default CallToAction
